import { IStandardApiState } from "../../models";

// EXAMPLE: { 1: [2, 3], 2: [4] } => [1, 2]
export const getRidesIdsWithNearby = (
  nearbyOtherRidesIdsBatch: IStandardApiState<Record<number, number[]>>,
): number[] => {
  const ridesIdsWithNearby: number[] = [];

  const nearbyOtherRidesData = nearbyOtherRidesIdsBatch.data || [];
  const entities = Object.entries(nearbyOtherRidesData);

  if (!entities.length) {
    return ridesIdsWithNearby;
  }

  for (const [rideId, nearbyIds] of entities) {
    if (nearbyIds.length) {
      ridesIdsWithNearby.push(Number(rideId));
    }
  }

  return ridesIdsWithNearby;
};

// EXAMPLE: { 1: [2, 3], 2: [4] } => [2, 3, 4]
export const getNearbyRidesIdsValues = (
  nearbyOtherRidesIdsBatch: IStandardApiState<Record<number, number[]>>,
): number[] => {
  const data = nearbyOtherRidesIdsBatch.data ?? {};

  return Object.values(data).flat();
};
